//FIXME the creatAnother button is not displaying!!!!!

import { Button, Box, Heading, Text, theme, ChakraProvider, Stack, VStack, Link} from '@chakra-ui/react';
import { WarningIcon, AddIcon } from '@chakra-ui/icons';
import skyFour from '../assets/skyFour.jpg';

export default function NotFound() {
  document.body.style.background = 'lightyellow';
  
  return (
    <ChakraProvider theme={theme}>
       <div style={{ 
        background: `url(${skyFour}) center center fixed no-repeat`,
        backgroundSize: "cover",
        height: "100vw",
        width: "100vw",
        position: "relative"
      }}>
        <div style={{ 
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 224, 0.4)"
        }}>
      <Box textAlign="center" py={10} px={6}>
        <VStack spacing='30px'>
          <VStack spacing="5px">
           <WarningIcon boxSize={'50px'} color={'grey'} />
        
            <Heading as="h2" size="xl" mt={6} mb={2}>
              404 - Page Not Found
            </Heading>
        
            <Text color={'black'}>
              Page could not be found. It might be a course with no reviews, 
            </Text>
            <Text color={'black'}> 
              it could have been moved, or the page may no longer exist.
            </Text>

            
          </VStack>
    
          <Stack direction='row' spacing={4}>
            <Button colorScheme='blue' variant='solid'>
              <Link href={'/'}>
              Take Me Home
              </Link>
            </Button>
          </Stack> 
        </VStack>
      </Box>
    </div>
    </div>
    </ChakraProvider>
  );
  }